const disabledStyles = _ref => {
  let {
    disabled = false
  } = _ref;
  return disabled ? {
    opacity: 0.4,
    pointerEvents: "none",
    userSelect: "none"
  } : {};
};

// used by Select, SelectList, and InputWrapper for Input, TextArea, and SuggestList
const focusStyles = _ref2 => {
  let {
    invalid,
    readOnly
  } = _ref2;
  const styles = {
    borderColor: readOnly ? "transparent" : invalid ? "border.status.critical.strong" : "utility.focus",
    outlineColor: invalid ? "border.status.critical.strong" : "utility.focus",
    outlineWidth: "0.188rem",
    outlineOffset: readOnly ? 0 : "-0.188rem"
  };
  return {
    ":focus-within": {
      ...styles
    },
    "&.focus-within": {
      ...styles
    }
  };
};

export { disabledStyles, focusStyles };
